import { Alert } from "@mui/material"
import { useTranslation } from "react-i18next"

const PlickErrors = ({
	errorListString,
}: {
	errorListString: string | null
}) => {
	const { t } = useTranslation()
	if (!errorListString) return undefined
	const listErrors = errorListString.split(" - ")

	return listErrors.map((el: string, index: number) => {
		return (
			<div key={`errorPlick_${index}`}>
				<Alert
					sx={{
						padding: "0 16px",
						backgroundColor: "rgba(244, 207, 22, 0.82)",
					}}
					severity="error"
				>
					<b>{t(el, { ns: "plick" })}</b>
				</Alert>
			</div>
		)
	})
}

export default PlickErrors
